import { motion } from "framer-motion";
import React from "react";
import Logo from "../../../assets/images/logo.jpeg";
import {
  FooterContainer,
  FooterCopy,
  FooterLink,
  FooterList,
  FooterMain,
  FooterSocial,
  FooterSocialLink,
} from "./FooterElements";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterMain>
      <FooterContainer>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <FooterList>
            <motion.div
              whileHover={{ rotate: 360 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            >
              <img
                src={Logo}
                alt="Rojan Acharya"
                height={50}
                width={50}
                className="border-2 border-white/30 rounded-full shadow-lg"
              />
            </motion.div>

            <li>
              <FooterLink to="home">Home</FooterLink>
            </li>
            <li>
              <FooterLink to="about">About</FooterLink>
            </li>
            <li>
              <FooterLink to="skills">Skills</FooterLink>
            </li>
            <li>
              <FooterLink to="works">Projects</FooterLink>
            </li>
            <li>
              <FooterLink to="certification">Certifications</FooterLink>
            </li>
            <li>
              <FooterLink to="contact">Contact</FooterLink>
            </li>
            <li>
              <FooterLink
                onClick={() =>
                  window.open(
                    "https://solution.rojanacharya.com/?ref=rojanacharya.com",
                    "_blank"
                  )
                }
              >
                Rojan Solves
              </FooterLink>
            </li>
          </FooterList>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <FooterSocial>
            <div className="text-xl items-center">Find me on</div>
            <FooterSocialLink
              href="https://www.linkedin.com/in/racharya404"
              target={"_blank"}
              aria-label="LinkedIn Profile"
            >
              <i className="bx bxl-linkedin-square"></i>
            </FooterSocialLink>

            <FooterSocialLink
              href="https://github.com/rjach"
              target={"_blank"}
              aria-label="GitHub Profile"
            >
              <i className="bx bxl-github"></i>
            </FooterSocialLink>

            <FooterSocialLink
              href="https://www.reddit.com/user/Official_Rojan"
              target={"_blank"}
              aria-label="Reddit Profile"
            >
              <i className="bx bxl-reddit"></i>
            </FooterSocialLink>

            <FooterSocialLink
              href="https://x.com/rojanacharya"
              target={"_blank"}
              aria-label="Twitter Profile"
            >
              <i className="bx bxl-twitter"></i>
            </FooterSocialLink>
          </FooterSocial>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <FooterCopy>
            Copyright &copy; {currentYear} Rojan Acharya. All rights reserved.
          </FooterCopy>
        </motion.div>
      </FooterContainer>
    </FooterMain>
  );
};

export default Footer;
